import axios from "axios";
import { API_HEADERS, CREATE_SHIPMENT_BASE_URL } from "../../constants";
import { IDeleteShipments } from "../../interfaces/IDeleteShipment";

export const deleteShipment = async (deleteShipmentData: IDeleteShipments) => {
  try {
    const result = await axios.post(
      `${CREATE_SHIPMENT_BASE_URL}/deleteShipment  `,
      { ...deleteShipmentData },
      {
        headers: API_HEADERS,
      }
    );

    return result.data as any;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error deleting Shipments", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
